import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { IconType } from '@se/cp.common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

interface IBoolIconRendererConfig {
    icon: string;
    negate: boolean;
    tooltip?: string;
    iconType?: IconType;
    color: string;
}

type TBoolIconRendererParams = ICellRendererParams<any, boolean, any> & { estensa: IBoolIconRendererConfig };

@Component({
    selector: 'se-bool-icon-renderer',
    templateUrl: './bool-icon-renderer.component.html',
    styleUrls: ['./bool-icon-renderer.component.scss'],
    imports: [TranslatePipe, MatIconModule, MatTooltipModule, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoolIconRendererComponent implements ICellRendererAngularComp {
    readonly EconTypes = IconType;
    readonly iconType = signal<IconType>(IconType.AngularMaterial);
    readonly icon = signal<string>('');
    readonly tooltip = signal<string>('');
    readonly color = signal<string>('');
    readonly isActive = signal<boolean>(false);

    isGreen = computed(() => {
        return this.color() && this.color() == 'green'
    });
    isYellow = computed(() => {
        return this.color() && this.color() == 'yellow'
    })

    refresh(params: TBoolIconRendererParams): boolean {
        const newValue = params.estensa?.negate ? !params.value : !!params.value;
        this.isActive.set(newValue);
        return true;
    }

    agInit(params: TBoolIconRendererParams): void {
        const initValue = (params.estensa && params.estensa.negate) ? !params.value : !!params.value;
        this.isActive.set(initValue);
        if (params.estensa) {
            const iconType = params.estensa.iconType;
            if (iconType) this.iconType.set(iconType);
            const icon = params.estensa.icon;
            if (icon) this.icon.set(icon);
            const tooltip = params.estensa.tooltip;
            if (tooltip) this.tooltip.set(tooltip);
            const color = params.estensa.color;
            if (color) this.color.set(color);
        } 
    }
}
